import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-height: 600px) {
    overflow: auto;
  }
`;

export const Form = styled.form`
  max-width: unset !important;
  display: flex;
  flex-direction: column;

  @media screen and (min-height: 600px) {
    overflow: auto;
  }
`;

export const List = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  margin-top: var(--gap);
  overflow: auto;

  @media screen and (min-height: 600px) {
    height: auto;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: var(--gap);
`;
